import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { GridProps } from './types';

export const GridItemMinusDrawer = styled((props: GridProps) => <Grid item {...props} />)`
    ${({ theme }) => `
        width: calc(100% - ${theme.appDrawer.width}px);
    `}
`;

export const DrawerWidthGrid = styled((props: GridProps) => <Grid {...props} item />)`
    ${({ theme }) => `
        width: ${theme.appDrawer.width}px;
    `}
`;